(function () {
  const input = document.getElementById('plant-search-input');
  const resultsContainer = document.getElementById('plant-search-results');

  if (!input || !resultsContainer) return;

  const i18n = {
    noResults: input.dataset.noResults || 'No results found for "{{ term }}".',
    error: input.dataset.error || 'Something went wrong.',
  };

  const scopeSelector = input.dataset.searchScope || '#genus-list';
  const itemSelector = input.dataset.itemSelector || 'genus-item';
  const titleSelector = input.dataset.titleSelector || '.genus-item-title h3';
  const commonSelector = input.dataset.commonSelector || '.genus-item-title span';
  const linkSelector = input.dataset.linkSelector || '.genus-item-title h3 a';

  const scope = document.querySelector(scopeSelector);
  if (!scope) return;

  const items = Array.from(scope.querySelectorAll(itemSelector));

  let debounceTimer;

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => search(input.value.trim()), 150);
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.plant-search')) {
      resultsContainer.hidden = true;
    }
  });

  function search(term) {
    if (term.length < 2) {
      resultsContainer.hidden = true;
      resultsContainer.innerHTML = '';
      return;
    }

    const lower = term.toLowerCase();
    const matches = items.filter((el) => {
      const title = el.querySelector(titleSelector)?.textContent.toLowerCase() || '';
      const common = el.querySelector(commonSelector)?.textContent.toLowerCase() || '';
      return title.includes(lower) || common.includes(lower);
    });

    if (matches.length === 0) {
      resultsContainer.innerHTML =
        '<div class="plant-search-message">' + i18n.noResults.replace('{{ term }}', term) + '</div>';
      resultsContainer.hidden = false;
      return;
    }

    const ul = document.createElement('ul');
    ul.classList.add('plant-search-list');

    for (const el of matches) {
      const anchor = el.querySelector(linkSelector);
      const titleText = el.querySelector(titleSelector)?.textContent.trim() || '';
      const commonText = el.querySelector(commonSelector)?.textContent.trim() || '';

      const li = document.createElement('li');
      li.classList.add('plant-search-item');

      const a = document.createElement('a');
      a.href = anchor ? anchor.href : '#';

      const titleSpan = document.createElement('span');
      titleSpan.classList.add('plant-search-title');
      titleSpan.textContent = titleText;
      a.appendChild(titleSpan);

      if (commonText) {
        const commonSpan = document.createElement('span');
        commonSpan.classList.add('plant-search-common');
        commonSpan.textContent = ' ' + commonText;
        a.appendChild(commonSpan);
      }

      li.appendChild(a);
      ul.appendChild(li);
    }

    resultsContainer.innerHTML = '';
    resultsContainer.appendChild(ul);
    resultsContainer.hidden = false;
  }
})();